import styled, { css } from 'styled-components';
import { ContainerDefault, WrapperDefault } from '../Shared/Shared';

export const FormRadioWrapper = styled(WrapperDefault)<{ isLoggedIn?: boolean }>`
  @media (max-width: 1200px) {
    padding-top: 24px;
    ${({ isLoggedIn }) =>
      isLoggedIn &&
      css`
        padding-bottom: 0;
      `}
  }
`;

export const FormRadioContainer = styled(ContainerDefault)`
  margin-top: 24px;
`;

export const FormRadioCustomizationsContainer = styled(ContainerDefault)`
  gap: 28px;
`;

export const CustomizationItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FormLabel = styled.label<{ borderColor: string; marginBottom?: number }>`
  cursor: pointer;
  user-select: none;
  ${({ marginBottom }) =>
    marginBottom &&
    css`
      margin-bottom: ${marginBottom}px;
    `}
  input[type='radio'] {
    position: absolute;
    opacity: 0;
    cursor: none;
    height: 0;
    width: 0;
    &:checked ~ div {
      border: solid 3px ${({ borderColor }) => borderColor};
    }
  }
  input[type='checkbox'] {
    position: absolute;
    opacity: 0;
    cursor: none;
    height: 0;
    width: 0;
    &:checked ~ div {
      border: solid 3px ${({ borderColor }) => borderColor};
    }
  }
`;

export const FormItemContainer = styled.div<{ disabled?: boolean; small?: boolean }>`
  cursor: pointer;
  user-select: none;
  padding: 12px 12px 20px 20px;
  border-radius: 6px;
  background-color: var(--static-white);
  border: solid 3px var(--static-white);
  opacity: 0.9;

  ${({ small }) =>
    small &&
    css`
      padding: 12px 12px 20px 20px;
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
    `}
`;

export const PriceTitleContainer = styled.div<{ noMargin?: boolean; justifyCenter?: boolean }>`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  ${({ justifyCenter }) =>
    justifyCenter &&
    css`
      justify-content: center;
      margin-bottom: 0;
    `}
  ${({ noMargin }) =>
    noMargin &&
    css`
      margin-bottom: 0;
    `}
`;

export const CustomizationTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const MainTitle = styled.span`
  font-size: 18px;
  font-weight: 900;
  color: var(--static-black);
`;

export const MainCustomizationsTitle = styled.span`
  font-size: 18px;
  font-weight: 900;
`;

export const Title = styled.span`
  font-size: 16px;
  font-weight: 800;
  color: var(--static-black);
`;
export const From = styled.span`
  font-size: 12px;
  font-weight: 300;
  color: var(--static-black);
`;
export const Price = styled.p`
  margin-left: auto;
  font-size: 18px;
  font-weight: 800;
  color: var(--static-black);
`;

export const CustomizationPrice = styled.p`
  margin-left: auto;
  font-size: 16px;
  font-weight: 500;
  color: var(--static-black);
`;

export const FormItemDescription = styled.span`
  font-size: 14px;
  color: var(--static-black);
`;

export const SessionsWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(1fr);
  grid-template-rows: 1fr;
  overflow-x: scroll;
  margin: 12px 0;
`;

export const SessionsContainer = styled.div`
  display: flex;
  overflow-x: scroll;
  gap: 12px;
  padding: 10px 24px;
`;

export const SlotGroupsContainer = styled.div`
  display: flex;
  gap: 12px;
  margin: 24px 0;
  align-items: center;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  min-height: 50px;

  @media (max-width: 1200px) {
    margin-left: 24px;
  }
`;

export const NewSlotGroupButton = styled.button<{ disabled: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  height: 38px;
  border: none;
  cursor: pointer;
  user-select: none;

  div {
    width: 38px;
    height: 38px;
    border: dashed 1.5px var(--dark-gray);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .plus-svg {
    height: 24px;
    width: 24px;
  }

  &:hover {
    div {
      background: var(--dark-gray);
      .plus-svg {
        stroke: var(--white);
        fill: var(--white);
      }
    }
  }

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
    `}
`;

export const SlotGroupButton = styled.button<{ disabled: boolean; selected?: boolean; completed?: boolean; manySlots?: boolean }>`
  background-color: var(--white);
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 24px;
  padding-left: 20px;

  border: solid 1px var(--white);
  white-space: nowrap;
  text-overflow: ellipsis;
  span {
    font-size: 18px;
    font-weight: 600;
    padding-right: 20px;
    color: var(--black);
    ${({ manySlots }) =>
      manySlots &&
      css`
        padding-right: 8px;
      `}
  }

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.3;
      border-radius: 15px;
      cursor: not-allowed;
      span {
        color: var(--black);
      }
    `}

  ${({ selected }) =>
    selected &&
    css`
      border: solid 1px var(--black);
      span {
        color: var(--black);
      }
    `}

  ${({ completed }) =>
    completed &&
    css`
      border: solid 1px var(--black);
      background-color: var(--black);
      span {
        color: var(--white);
      }
    `}
`;

export const CloseButton = styled.div<{ selected?: boolean; completed?: boolean }>`
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  .minus-svg {
    height: 24px;
    width: 24px;
  }
  ${({ completed }) => {
    if (completed) {
      return css`
        .minus-svg {
          stroke: var(--white);
          fill: var(--white);
        }
      `;
    }
    return css`
      &:hover {
        background: var(--white);
        .minus-svg {
          stroke: var(--white);
          fill: var(--white);
        }
      }
    `;
  }}

  &:hover {
    background: var(--dark-gray);
    .minus-svg {
      stroke: var(--white);
      fill: var(--white);
    }
  }
`;
